import { useEffect, useState } from 'react';

let cached = null;

export const getCheckoutEnabled = () => {
  if (!cached) {
    cached = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/checkout/config`)
      .then((r) => r.json())
      .then((d) => d.enabled === true)
      .catch(() => {
        cached = null;
        return false;
      });
  }
  return cached;
};

export const useCheckoutEnabled = () => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    let alive = true;
    getCheckoutEnabled().then((v) => alive && setEnabled(v));
    return () => { alive = false; };
  }, []);
  return enabled;
};

export const PAUSE_MESSAGE =
  "We're briefly pausing new orders while we finalize our organization. Join the waitlist and we'll email you the moment we reopen. No payment is taken and no delivery is scheduled yet.";
